<template>
    <ValidationProvider
        class="relative appearance-none"
        tag="div"
        :vid="vid"
        :rules="rules"
        :name="name"
        :mode="mode"
        v-slot="{ errors, required, ariaInput, ariaMsg }"
    >
        <textarea
            :class="[{ 'hasError': errors[0]}, taClass]"
            :style="taStyle"
            :type="type"
            :rows="rows"
            :placeholder="placeholder"
            ref="textarea"
            v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)"
            :disabled="disabled"
            :readonly="readonly"
            v-beautify.literal="vBeautify"
            v-bind="ariaInput"
            v-tooltip.bottom-end="{
                content: errors[0],
                template: tooltipTemplate,
            }"
        />
    </ValidationProvider>
</template>

<script>

export default {
    props: {
        disabled: {
          type: Boolean,
          default: false
        },

        readonly: {
          type: Boolean,
          default: false
        },

        vid: {
            type: String,
            default: undefined
        },

        name: {
            type: String,
            default: ""
        },

        mode: {
            type: String,
            default: "lazy"
        },

        rules: {
            type: [Object, String],
            default: ""
        },

        placeholder: {
            type: String,
            default: ""
        },

        vBeautify: {
            default: '',
            type: String
        },

        taStyle: {
            type: String,
            default: ''
        },

        taClass: {
            type: String,
            default: ''
        },
        rows: {
            default: 2
        },
        type: {
            type: String,
            default: "text",
            validator(value) {
                return [
                    "url",
                    "text",
                    "password",
                    "tel",
                    "search",
                    "number",
                    "email"
                ].includes(value);
            }
        },

        value: {
            type: String,
            default: ""
        }
    },

    computed: {
        tooltipTemplate: function () {
            return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
        }
    }
};
</script>

<style lang="scss">

.tooltip-inner.hasError {
    text-shadow: none !important;
    border-color: #d04444 !important;
    background-color: #d04444 !important;
    box-shadow: 4px 4px 8px #dd4b3973 !important;
}
.tooltip-arrow.hasError {
    border-color: #d04444 !important;
}
</style>
